import{a}from"./chunk-RAAYCPUM.js";function x(...e){return a(c,e)}function c(e,o,i){let t={};for(let[r,n]of e.entries()){let u=o(n,r,e),m=i(n,r,e);t[u]=m}return t}export{x as a};
